import { TCartItem } from '@/entities/cart'

import { ProductType } from '@/shared/types/product'

/**
 * Get list of cart's products and return list of ids in string type
 * @param products - list of products from cart
 */
export const getProductListString = (products: TCartItem[]): string =>
	products
		.map(item => {
			let itemString = ``

			if (item.TYPE_PRODUCTS === ProductType.Product || item.TYPE_PRODUCTS === ProductType.Accessory) return itemString

			itemString += `ids[]=${item.ID_BASKET}`

			return itemString
		})
		.filter(value => !!value)
		.join('&')
